import React from "react";
import "./Blob.css";
// import bubblesVid from "../../../vids/bubbles1.mp4";
import analyticsTracker from "../../../utils/analytics";



const Blob = (props) => {
    const { bgImage, link, altText, title } = props;
    const handleClick = (e) => {
        try { analyticsTracker.trackServiceClick(title || 'Offer', link); } catch (err) { /* noop */ }
    };

    return (
        <div className="circle" style={{backgroundImage: `url(${bgImage})`, backgroundSize: '200%'}}>
            <a className="welcome-links" href={link} onClick={handleClick}>
                <img src={bgImage} alt={altText} title={`Enter ${title}`} />
                <p></p>
            </a>
        </div>
    );
}

export default Blob;